export default __webpack_public_path__ + "static/media/touchZero.beb8e534.svg";